export function setSessionStorage({ key, value, isNoJSONStringify = false }) {
    const item = {
        value
    };
    try {
        if (navigator.cookieEnabled && typeof window.sessionStorage !== 'undefined') {
            sessionStorage.setItem(key, isNoJSONStringify ? value : JSON.stringify(item));
        } else {
            console.log('Failed to access window session storage');
        }
    } catch (error) {
        console.log('Failed to set session storage', error);
    }

    return item;
}

export function getSessionStorage({ key }) {
    try {
        if (navigator.cookieEnabled && typeof window.sessionStorage !== 'undefined') {
            return sessionStorage.getItem(key);
        } else {
            console.log('Failed to access window session storage');
        }
    } catch (error) {
        console.log('Failed to set session storage', error);
    }

    return null;
}
